import { jsxs as C, jsx as l, Fragment as ge } from "react/jsx-runtime";
import { c as A } from "./index-65016bfa.mjs";
import { forwardRef as me, useRef as z, useState as L, useEffect as ee, useMemo as ye } from "react";
import p, { css as u, useTheme as ve } from "styled-components";
import "@fcamna/shared-component-foundations";
import { u as fe } from "./useQuantum-50e8fd44.mjs";
import "./isClient-ec947a14.mjs";
import { c as $e } from "./combineRefs-90f27925.mjs";
import "./useSlots-a1aa6a84.mjs";
import { D } from "./index-2be68378.mjs";
import { Icon as R } from "./icon.js";
import { I, H as be } from "./helperText-d9646f54.mjs";
import { L as Ee } from "./label-33699561.mjs";
import { TagsGroup as Ce } from "./tags.js";
import { u as Se } from "./useAccessibilityProps-2f24cf29.mjs";
import { u as Ie } from "./uniqueId-321287e8.mjs";
import { S as Oe } from "./screenReaderOnly-fd82ed96.mjs";
import { TextInput as Ne } from "./textInput.js";
import "./_commonjsHelpers-92157f1b.mjs";
import "react-dom";
import "./useWindowSize-88e90e04.mjs";
import "./checkbox.js";
import "./setup-0f23222d.mjs";
import "./table.js";
import "@fcamna/shared-icons";
import "./popupTip.js";
import "./usePopoverIndex-b3a93ecd.mjs";
import "./Aria-f5e019e2.mjs";
import "./button.js";
import "./closeButton.js";
import "./iconButton.js";
import "./divider.js";
import "./focusTrap.js";
import "./useClient-0bbce34e.mjs";
import "./getElementPosition-a8642645.mjs";
import "./link.js";
import "./tooltip.js";
import "./menu.js";
import "./radio.js";
import "./childrenCountCheck-785fa19a.mjs";
const We = p.div`
  ${({
  theme: {
    components: { selectInput: n }
  }
}) => u(n.multiSelectInput.Container)};
`, we = p.div`
  &.multiSelect-mainWrapper {
    ${({
  theme: {
    components: { selectInput: n }
  }
}) => u(n.multiSelectInput.MultiSelectContainer)};
  }
`, Re = p.div`
  ${({
  theme: {
    components: { selectInput: n }
  }
}) => u(n.multiSelectInput.Selections)};
`, Pe = p.input`
  &.multiSelect-search {
    ${({
  theme: {
    components: { selectInput: n }
  }
}) => u(n.multiSelectInput.Search)};
  }
`, ke = p.button`
  ${({
  theme: {
    components: { selectInput: n }
  }
}) => u(n.multiSelectInput.ClearButton)};
`, _e = p.button`
  &.multiSelect-dropdownIcon {
    ${({
  theme: {
    components: { selectInput: n }
  }
}) => u(n.multiSelectInput.DropdownIcon)};
  }
`, He = p.div`
  &.multiSelect-searchSectionContainer {
    ${({
  theme: {
    components: { selectInput: n }
  }
}) => u(n.multiSelectInput.SearchSectionContainer)};
  }
`, Me = p.div`
  ${({
  theme: {
    components: { selectInput: n }
  }
}) => u(n.multiSelectInput.IconWrapper)};
`, xe = p.div`
  ${({
  theme: {
    components: { selectInput: n }
  }
}) => u(n.multiSelectInput.InputWrapper)};
`, ue = "MultiSelect", Ae = (n, h) => {
  let r = n.trim();
  return r = r.replace(/[.*+?^${}()|[\]\\]/g, "\\$&"), h.filter((o) => `${o.label}${o.value}`.search(new RegExp(r, "i")) < 0).map((o) => o.value);
}, Rt = me(
  ({
    errorMessage: n,
    placeholder: h = "Select...",
    isDisabled: r = !1,
    options: o,
    selected: f,
    onOptionSelect: b,
    onClickClear: P,
    size: S = "medium",
    helperText: k,
    onChange: B,
    onBlur: F,
    label: _,
    isRequired: q = !1,
    inputState: H = I.NONE,
    required: K = q,
    showRequiredIndicator: J = K,
    isSelectAll: M = !1,
    className: te = "",
    labelProp: ne = {
      label: _,
      showRequiredIndicator: J,
      success: !1
    },
    infoProp: X,
    trailingText: le,
    isSearchable: Q = !0,
    tagGroupProp: U,
    noResultText: G = "No result found",
    helperTextProp: O,
    menuHeader: j,
    exceedOverflow: ae = !1,
    ...v
  }, re) => {
    var T, t;
    const Y = fe({ label: "Multi Select Input" }), g = z(Ie(v.id ?? ue)), N = Object.keys(f), W = z(null), [E, w] = L(""), [d, i] = L(!1), [V, y] = L([]), x = ve();
    let s = H || I.NONE, a = O;
    H || (s = n ? I.ERROR : I.NONE), O || (a = {
      [s === I.ERROR ? "secondaryProp" : "defaultProp"]: {
        helperText: k,
        id: `${s === I.ERROR ? "invalid" : "valid"}_${ue}_helperText`,
        state: s
      }
    });
    const $ = {
      defaultId: ((T = a == null ? void 0 : a.defaultProp) == null ? void 0 : T.id) || `default_${g.current}_message_id`,
      secondaryId: ((t = a == null ? void 0 : a.secondaryProp) == null ? void 0 : t.id) || `secondary_${g.current}_message_id`
    };
    ee(() => {
      y(Ae(E, o));
    }, [E, o]), ee(() => {
      var e;
      d === !0 ? (e = W.current) == null || e.focus() : w("");
    }, [d]);
    const oe = Se("combobox", {
      ariaExpanded: d,
      ariaDisabled: r,
      ariaRequired: K,
      ariaInvalid: H === "caution" || H === "error",
      ariaHasPopup: "listbox",
      ariaControls: g.current,
      ariaLabelledBy: `${g.current}_label_id ${$.defaultId} ${$.secondaryId}`
    }), Z = (e) => {
      var m;
      P && P(e), (m = W.current) == null || m.focus();
    }, ce = (e) => {
      var m;
      (m = W.current) == null || m.focus(), e.target === e.currentTarget && i(!d);
    }, ie = (e, m) => {
      var c;
      e.preventDefault(), b(m, e), (c = W.current) == null || c.focus(), B && B(e);
    }, se = (e) => {
      w(e.target.value);
    };
    return /* @__PURE__ */ C(
      We,
      {
        className: te,
        ...v,
        ...Y,
        children: [
          /* @__PURE__ */ l(
            Ee,
            {
              labelProp: {
                id: `${g.current}_label_id`,
                showRequiredIndicator: J,
                htmlFor: v.id || g.current,
                ...ne
              },
              infoProp: {
                infoText: "",
                infoType: "tooltip",
                popupTipHeader: "Info",
                ...X
              },
              trailingText: le
            }
          ),
          /* @__PURE__ */ C(
            D,
            {
              className: "no-filter",
              menuOpen: !r && d,
              menuHeader: j || (M ? "select_all" : "default"),
              handleMenuOpen: (e) => i(e),
              onChange: ie,
              type: "multiple",
              isDisabled: r,
              exceedOverflow: ae,
              uniqueIdentifier: g.current,
              hiddenItems: V,
              noResultText: G,
              children: [
                /* @__PURE__ */ l(D.Control, { children: /* @__PURE__ */ l(
                  we,
                  {
                    className: A([
                      [
                        "multiSelect-mainWrapper",
                        `multiSelect-mainWrapper--${S}`,
                        d && "multiSelect-mainWrapper--isOpen",
                        s && s !== "none" && `multiSelect-mainWrapper--${s}`,
                        r && "multiSelect-mainWrapper--disabled"
                      ]
                    ]),
                    onBlur: F,
                    onKeyUp: (e) => {
                      e.key === " " && e.stopPropagation(), e.key !== "Tab" && (d || i(!0));
                    },
                    "data-testid": "multiSelect-wrapper",
                    children: /* @__PURE__ */ C(
                      He,
                      {
                        className: A([
                          ["multiSelect-searchSectionContainer", r && "multiSelect-searchSectionContainer--disabled"]
                        ]),
                        children: [
                          N.length > 0 && /* @__PURE__ */ l(
                            Re,
                            {
                              onClick: ce,
                              "data-testid": "selection-wrapper",
                              onKeyDown: (e) => {
                                (e.key === "Enter" || e.key === " " && r) && (e.preventDefault(), e.stopPropagation());
                              },
                              children: U ? /* @__PURE__ */ l(Ce, { ...U, children: N.map((e) => f[e]) }) : N.map((e) => f[e])
                            }
                          ),
                          /* @__PURE__ */ C(xe, { children: [
                            /* @__PURE__ */ l(
                              Pe,
                              {
                                id: `control-${g.current}`,
                                disabled: r,
                                placeholder: h,
                                onChange: se,
                                value: E,
                                size: S,
                                ref: $e(re, W),
                                required: K,
                                className: A([
                                  [
                                    "multiSelect-search",
                                    `multiSelect-search--${S}`,
                                    d && "multiSelect-search--isOpen",
                                    r && "multiSelect-search--disabled",
                                    Q && d && "multiSelect-search--cursor-text"
                                  ]
                                ]),
                                "data-testid": "search-input-test-id",
                                onKeyDownCapture: (e) => {
                                  e.key === "Enter" && (e.preventDefault(), e.stopPropagation());
                                },
                                readOnly: !Q || j === "local_search",
                                ...v,
                                ...oe
                              }
                            ),
                            /* @__PURE__ */ C(Me, { children: [
                              N.length > 0 && !r && /* @__PURE__ */ l(
                                ke,
                                {
                                  onClick: Z,
                                  disabled: r,
                                  className: A(["IconWrapper", S !== "small" && "IconWrapper--offset"]),
                                  "aria-label": "clear",
                                  children: /* @__PURE__ */ l(
                                    R,
                                    {
                                      name: "cancelCloseFilled",
                                      ...x.components.selectInput.multiSelectInput.InlineStyles.closeButtonStyle
                                    }
                                  )
                                }
                              ),
                              /* @__PURE__ */ l(
                                _e,
                                {
                                  "aria-label": "dropdown",
                                  onKeyUp: (e) => {
                                    r && e.stopPropagation();
                                  },
                                  tabIndex: -1,
                                  "data-testid": "dropdown-test-id",
                                  className: A([
                                    [
                                      "multiSelect-dropdownIcon",
                                      `multiSelect-dropdownIcon--${S}`,
                                      r && "multiSelect-dropdownIcon--disabled"
                                    ]
                                  ]),
                                  children: d ? /* @__PURE__ */ l(R, { name: "caretUp" }) : /* @__PURE__ */ l(R, { name: "caretDown" })
                                }
                              )
                            ] })
                          ] })
                        ]
                      }
                    )
                  }
                ) }),
                o.map((e) => /* @__PURE__ */ l(
                  D.Item,
                  {
                    id: e.value,
                    isSelected: !!N.includes(e.value),
                    label: e.label,
                    value: e.value,
                    description: e.description,
                    disabled: e.disabled
                  },
                  e.value
                ))
              ]
            }
          ),
          /* @__PURE__ */ l(
            be,
            {
              secondaryProp: {
                id: $.secondaryId,
                ...a == null ? void 0 : a.secondaryProp,
                state: s
              },
              defaultProp: {
                id: $.defaultId,
                helperText: k,
                ...a == null ? void 0 : a.defaultProp
              }
            }
          )
        ]
      }
    );
  }
), Le = p.div`
  &.SingleSelect-Container {
    ${({
  theme: {
    components: { selectInput: n }
  }
}) => u(n.singleSelectInput.Container)};
  }
`, de = p.span`
  &.SingleSelect-EndAdornmentWrapper {
    ${({
  theme: {
    components: { selectInput: n }
  }
}) => u(n.singleSelectInput.EndAdornmentWrapper)};
  }
`, De = p.span`
  &.SingleSelect-CloseIconWrapper {
    ${({
  theme: {
    components: { selectInput: n }
  }
}) => u(n.singleSelectInput.CloseIconWrapper)};
  }
`, Fe = p(R)`
  &.SingleSelect-CloseIcon {
    ${({
  theme: {
    components: { selectInput: n }
  }
}) => u(n.singleSelectInput.CloseIcon)};
  }
`, Ke = p.span`
  &.SingleSelect-LeadIconWrapper {
    ${({
  theme: {
    components: { selectInput: n }
  }
}) => u(n.singleSelectInput.LeadIconWrapper)};
  }
`, Ue = "SingleSelect", je = (n, h) => {
  let r = n == null ? void 0 : n.trimStart();
  return r = r.replace(/[.*+?^${}()|[\]\\]/g, "\\$&"), h.filter((o) => `${o.label}${o.value}`.search(new RegExp(r, "i")) < 0).map((o) => o.value);
}, Pt = me(
  ({
    label: n,
    errorMessage: h,
    placeholder: r = "Select...",
    isDisabled: o = !1,
    options: f,
    onChange: b,
    onBlur: P,
    selected: S = "",
    onOptionSelect: k,
    size: B = "medium",
    helperText: F,
    isRequired: _ = !1,
    required: q = _,
    maxItems: H = 8,
    showRequiredIndicator: K = _,
    className: J = "",
    labelProp: M = {
      label: n,
      showRequiredIndicator: K,
      success: !1
    },
    infoProp: te,
    trailingText: ne,
    isSearchable: X = !0,
    noResultText: le,
    showClear: Q = !1,
    isDefaultSelect: U = !1,
    inputState: G,
    helperTextProp: O = {
      ...F && { defaultProp: { helperText: F } },
      ...h && {
        secondaryProp: { helperText: h }
      }
    },
    accessibilityOptions: j = {},
    exceedOverflow: ae = !1,
    startAdornment: v,
    menuDirection: re = "down_auto",
    ...Y
  }, g) => {
    const N = fe({ label: "Single Select Input" }), W = z(Ie(Ue)), E = Y.id || W.current, [w, d] = L([]), [i, V] = L(!1), [y, x] = L(""), s = z(null);
    let a = { label: "", value: "" }, $ = G || I.NONE;
    G || ($ = h ? I.ERROR : I.NONE);
    const oe = Se("combobox", {
      ariaExpanded: i,
      ariaDisabled: o,
      ariaRequired: _ || (M == null ? void 0 : M.showRequiredIndicator) || q,
      ariaInvalid: I.ERROR === $ || I.CAUTION === $,
      ariaHasPopup: "listbox",
      ariaControls: `list-${E}`,
      ...j.inputAccessibilityProps
    }), Z = (t) => {
      var e, m;
      t.preventDefault(), t.stopPropagation(), x(""), k({ label: "", value: "" }), Object.defineProperty(t, "target", {
        value: a
      }), t.target = { value: JSON.stringify(a) }, b && b(t), s != null && s.current && ((m = (e = s.current) == null ? void 0 : e.querySelector("input")) == null || m.focus());
    }, ce = (t) => {
      t.currentTarget.contains(t.relatedTarget) || (Object.defineProperty(t, "target", {
        ...t.target,
        value: JSON.stringify(a)
      }), P == null || P(t));
    }, ie = (t) => {
      if (t.key !== "Enter")
        t == null || t.preventDefault();
      else if (i && U) {
        if (t == null || t.preventDefault(), t == null || t.stopPropagation(), f.length === w.length)
          return;
        k(a);
        const e = new Event("change", {});
        Object.defineProperty(e, "target", {
          value: a,
          writable: !0
        }), e.target = { value: a }, b && b(e), V(!1);
      }
      t.key === " " && (t == null || t.stopPropagation()), t.key !== "Tab" && t.key !== "Shift" && !i && V(!0);
    };
    ee(() => {
      if (i)
        f.some((e) => e.label === y) && x("");
      else {
        let t = S;
        f.forEach((e) => {
          e.value === S && (t = e.label);
        }), x(t);
      }
    }, [S, i, f]), ee(() => {
      d(je(y, f));
    }, [y, f]);
    const se = () => {
      let t = !0, e = { ...a };
      const m = f.map((c, he) => {
        let pe = t && S === c.value && !w.includes(c.value);
        return S === c.value && (e = { label: c.label, value: c.value }), U && t && !c.disabled && !w.includes(c.value) && (t = !1, pe = !0, a = { label: c.label, value: c.value }), /* @__PURE__ */ l(
          D.Item,
          {
            label: c.label,
            value: c.value,
            description: c.description,
            isSelected: pe,
            disabled: c.disabled || !1
          },
          he
        );
      });
      return t && (a = { ...e }), m;
    }, T = ye(() => typeof v == "string" ? /* @__PURE__ */ l(R, { name: v }) : v, [v]);
    return /* @__PURE__ */ C(
      Le,
      {
        className: A([
          "SingleSelect-Container",
          { "SingleSelect-Container--cursor-text": X && i },
          J
        ]),
        onBlur: ce,
        ...Y,
        ...N,
        children: [
          /* @__PURE__ */ C(
            D,
            {
              className: "no-filter",
              onChange: (t, e) => {
                t == null || t.preventDefault(), k(e), b && b(t);
              },
              menuOpen: i,
              menuDirection: re,
              handleMenuOpen: (t) => V(t),
              closeOnSelect: !0,
              isDisabled: o,
              maxItems: H,
              uniqueIdentifier: E,
              hiddenItems: w,
              noResultText: le,
              exceedOverflow: ae,
              children: [
                /* @__PURE__ */ l(D.Control, { children: /* @__PURE__ */ l(
                  Ne,
                  {
                    labelProp: { htmlFor: `control-${E}`, ...M },
                    infoProp: {
                      infoText: "",
                      infoType: "tooltip",
                      popupTipHeader: "Info",
                      ...te
                    },
                    inputState: $,
                    trailingText: ne,
                    disabled: o,
                    textSize: B,
                    isInvalid: !!h,
                    helperText: i ? "" : F,
                    helperTextProp: i ? O == null ? void 0 : O.secondaryProp : O,
                    required: _ || q,
                    id: `control-${E}`,
                    placeholder: r,
                    onChange: (t) => {
                      x(t.target.value);
                    },
                    onKeyUp: ie,
                    value: y,
                    ref: s,
                    inputRef: g,
                    readOnly: !X,
                    ...oe,
                    endAdornmentProp: {
                      endAdornment: i ? /* @__PURE__ */ l(de, { className: "SingleSelect-EndAdornmentWrapper", children: /* @__PURE__ */ l(
                        R,
                        {
                          name: "caretUp",
                          style: { pointerEvents: "none" }
                        }
                      ) }) : /* @__PURE__ */ C(ge, { children: [
                        !i && Q && (y == null ? void 0 : y.trim()) && /* @__PURE__ */ l(
                          De,
                          {
                            tabIndex: 0,
                            onKeyUp: (t) => {
                              t.preventDefault(), t.stopPropagation(), (t.key === "Enter" || t.key === " ") && Z(t);
                            },
                            className: "SingleSelect-CloseIconWrapper",
                            "data-testid": "data-close-icon",
                            onClick: Z,
                            children: /* @__PURE__ */ l(
                              Fe,
                              {
                                name: "cancelCloseFilled",
                                className: "SingleSelect-CloseIcon"
                              }
                            )
                          }
                        ),
                        /* @__PURE__ */ l(de, { className: "SingleSelect-EndAdornmentWrapper", children: /* @__PURE__ */ l(
                          R,
                          {
                            name: "caretDown",
                            style: { pointerEvents: "none" }
                          }
                        ) })
                      ] })
                    },
                    startAdornmentProp: T ? {
                      startAdornment: /* @__PURE__ */ l(
                        Ke,
                        {
                          className: "SingleSelect-LeadIconWrapper",
                          "data-testid": "single-select-lead-icon",
                          children: T
                        }
                      )
                    } : void 0
                  }
                ) }),
                se()
              ]
            }
          ),
          /* @__PURE__ */ l(
            Oe,
            {
              role: "alert",
              "aria-live": "assertive",
              children: y
            }
          )
        ]
      }
    );
  }
);
export {
  Rt as MultiSelectInput,
  Pt as SingleSelectInput
};
